import React from 'react';
import { Button, Tooltip } from 'antd';
import { EditOutlined, ExportOutlined } from '@ant-design/icons';
import I18n from 'i18n-js';
import { string, func } from 'prop-types';
import JiraIcon from './JiraIcon';

const JiraLinkCard = ({ url, issueKey, onEdit }) => (
  <div className="tickets-index-page__jira-link-card">
    <span className="tickets-index-page__jira-link-card__icon">
      <JiraIcon />
    </span>

    <div className="tickets-index-page__jira-link-card__body">
      <span className="tickets-index-page__jira-link-card__key">{issueKey}</span>
      <Tooltip title={url}>
        <a
          className="tickets-index-page__jira-link-card__url"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {url}
        </a>
      </Tooltip>
    </div>

    <div className="tickets-index-page__jira-link-card__actions">
      <Tooltip title={I18n.t('tickets.form.jira_open')}>
        <Button
          type="text"
          size="small"
          icon={<ExportOutlined />}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
        />
      </Tooltip>
      <Tooltip title={I18n.t('tickets.form.jira_edit')}>
        <Button type="text" size="small" icon={<EditOutlined />} onClick={onEdit} />
      </Tooltip>
    </div>
  </div>
);

JiraLinkCard.propTypes = {
  url: string.isRequired,
  issueKey: string.isRequired,
  onEdit: func.isRequired,
};

export default JiraLinkCard;
